<template>
    <div>
        <v-select :multiple="false" :options="optionsFormatos" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedFormatos" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "formatos",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedFormatos:[],
            optionsFormatos:[],
            cvecadena:0
        }
    },
    mounted() {

    },
    methods:{
        getDataFormatos(){ let $this = this;
            axios
                .post('/api/AdminCatalogos/formatosMain',{cadena:this.cvecadena})
                .then(function (r){
                    $this.optionsFormatos = r.data;
                });
        },
        setCambio(){
            this.$emit('cambioFormato');
        }
    }
}
</script>

<style scoped>

</style>
